var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoolerPowerOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_175893039428972466786749321354967394324",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 22,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6845 9.87338C17.6845 11.1221 17.719 12.3595 17.6731 13.6085C17.6387 14.8917 16.1838 15.6364 15.0955 14.9488C14.6142 14.6397 14.305 14.2041 14.305 13.6199C14.2936 11.1107 14.282 8.59025 14.305 6.0811C14.3164 5.18734 15.1068 4.48842 16.0006 4.50015C16.8944 4.51149 17.6504 5.21041 17.6735 6.10413C17.7076 7.35289 17.6845 8.61295 17.6845 9.87338Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52527 20.7497C8.54742 19.1441 8.15187 17.1802 8.57307 15.2485C8.7192 14.5756 8.95339 13.9524 9.25868 13.3649C9.56232 12.7813 9.93776 12.2311 10.3684 11.7014L10.3745 11.6936C10.6516 11.3458 10.7597 10.9395 10.7159 10.5556C10.6724 10.1721 10.4765 9.80735 10.1478 9.54267L10.141 9.53654C9.8049 9.26924 9.40545 9.15688 9.01899 9.19974C8.63704 9.24161 8.26357 9.43552 7.97227 9.77879C6.83169 11.1295 6.05226 12.5802 5.64727 14.1245C5.24618 15.6548 5.21176 17.2812 5.5547 18.9976C6.04705 21.4648 7.40521 23.5924 9.30088 25.1013C11.1855 26.6017 13.603 27.4922 16.2298 27.5L16.5347 27.4714C16.8306 27.4464 17.2141 27.4136 17.5737 27.3421L17.5795 27.3417C19.1462 27.092 20.5511 26.574 21.7761 25.787C22.9882 25.0083 24.0267 23.9645 24.8751 22.6556C25.9318 21.0256 26.5187 19.3427 26.6483 17.6234C26.7792 15.8865 26.443 14.1088 25.6538 12.3082C25.4454 11.8357 25.1969 11.3843 24.9153 10.9543C24.6321 10.5224 24.3155 10.1122 23.9725 9.72444C23.7381 9.45939 23.4506 9.28954 23.146 9.22004C22.8368 9.1496 22.5062 9.18074 22.1918 9.3165C21.8843 9.45226 21.6413 9.66887 21.4819 9.93584C21.3221 10.2031 21.2438 10.5256 21.2646 10.8715C21.2948 11.3151 21.5653 11.6588 21.8407 12.0082L21.8612 12.0341C22.6043 12.9588 23.1074 13.9493 23.3655 14.998C23.6231 16.0427 23.637 17.1466 23.4038 18.3018C23.3724 18.4587 23.337 18.6104 23.2987 18.7549C22.7816 20.7058 21.556 22.2724 19.9639 23.2497C18.3729 24.2259 16.4142 24.6143 14.4302 24.2123C14.2721 24.1804 14.1171 24.1444 13.9671 24.1045C12.0604 23.6017 10.5015 22.3536 9.52527 20.7499V20.7497Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_175893039428972466786749321354967394324)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0Z",
    fill: "url(#hinava_random_uuid_253730221528933109919627658332421856410)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_253730221528933109919627658332421856410",
    x1: 16,
    y1: 10.5107,
    x2: 16,
    y2: 29.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolerPowerOn);
export default __webpack_public_path__ + "static/media/cooler-power-on.b635b5d094e0e8dd00a91cdf26857b2c.svg";
export { ForwardRef as ReactComponent };